// Mock data for filmmaking website

export const heroSlides = [
  {
    id: 1,
    title: "Cinematic Excellence",
    subtitle: "Crafting Visual Stories That Captivate",
    backgroundImage: "https://images.unsplash.com/photo-1758390851386-79c99432120e",
    bgColor: "#151515",
    textColor: "#FF3225"
  },
  {
    id: 2,
    title: "Documentary Mastery",
    subtitle: "Authentic Stories, Powerful Impact",
    backgroundImage: "https://images.unsplash.com/photo-1676994836537-5c18e7cf3dbf",
    bgColor: "#1a0000",
    textColor: "#FFFFFF"
  },
  {
    id: 3,
    title: "Commercial Brilliance",
    subtitle: "Elevating Brands Through Motion",
    backgroundImage: "https://images.unsplash.com/photo-1638961811114-65f0702701ec",
    bgColor: "#000000",
    textColor: "#FF3225"
  }
];

export const services = [
  {
    id: 1,
    title: "Commercial Production",
    description: "High-impact commercials that drive brand engagement and deliver measurable results for agencies and brands worldwide.",
    icon: "Video"
  },
  {
    id: 2,
    title: "Documentary Films",
    description: "Authentic storytelling that captures real moments, emotions, and truths with cinematic excellence.",
    icon: "Film"
  },
  {
    id: 3,
    title: "Brand Content",
    description: "Strategic visual content that amplifies your brand voice and connects with your target audience.",
    icon: "Clapperboard"
  },
  {
    id: 4,
    title: "Creative Direction",
    description: "End-to-end creative vision from concept to final cut, ensuring every frame serves your story.",
    icon: "Lightbulb"
  }
];

export const portfolio = [
  {
    id: 1,
    title: "Tech Innovation",
    category: "Commercial",
    description: "30-second commercial for leading tech brand, showcasing cutting-edge innovation",
    image: "https://images.unsplash.com/photo-1637441210953-5d99e6d6c37e",
    client: "TechCorp Global",
    year: "2024",
    bgColor: "#FF3225"
  },
  {
    id: 2,
    title: "Urban Stories",
    category: "Documentary",
    description: "Feature documentary exploring urban transformation and community resilience",
    image: "https://images.unsplash.com/photo-1683089884249-a6c5f364edaf",
    client: "Independent",
    year: "2024",
    bgColor: "#151515"
  },
  {
    id: 3,
    title: "Sustainable Future",
    category: "Brand Content",
    description: "Environmental campaign celebrating sustainable practices and green innovation",
    image: "https://images.unsplash.com/photo-1761872936122-4aca27d3f258",
    client: "EcoVision Inc",
    year: "2023",
    bgColor: "#FF3225"
  },
  {
    id: 4,
    title: "Athletic Excellence",
    category: "Commercial",
    description: "Dynamic sports commercial capturing peak performance and determination",
    image: "https://images.unsplash.com/photo-1759187766895-86c46a068315",
    client: "SportGear Pro",
    year: "2023",
    bgColor: "#1a0000"
  },
  {
    id: 5,
    title: "Cultural Heritage",
    category: "Documentary",
    description: "Documentary series preserving traditional craftsmanship and cultural stories",
    image: "https://images.unsplash.com/photo-1637441394275-7bc7779f3838",
    client: "Heritage Foundation",
    year: "2024",
    bgColor: "#151515"
  },
  {
    id: 6,
    title: "Luxury Lifestyle",
    category: "Commercial",
    description: "Premium brand commercial emphasizing craftsmanship and elegance",
    image: "https://images.unsplash.com/photo-1612872750175-5b67ab0a6011",
    client: "Luxe Brands",
    year: "2023",
    bgColor: "#FF3225"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Chen",
    position: "Creative Director, Ogilvy",
    company: "Ogilvy",
    quote: "Their ability to translate brand vision into compelling visual narratives is unmatched. Every project exceeded expectations.",
    rating: 5
  },
  {
    id: 2,
    name: "Marcus Rodriguez",
    position: "Brand Manager, Nike",
    company: "Nike",
    quote: "Working with this team elevated our campaign to award-winning status. Their cinematic approach brought authenticity and impact.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Thompson",
    position: "CEO, Startup Ventures",
    company: "Startup Ventures",
    quote: "From concept to delivery, they demonstrated professionalism and creativity. Our brand video drove a 300% increase in engagement.",
    rating: 5
  }
];

export const stats = [
  { number: "150+", label: "Projects Delivered" },
  { number: "50+", label: "Global Brands" },
  { number: "15+", label: "Awards Won" },
  { number: "10+", label: "Years Experience" }
];

export const showreelVideo = {
  url: "https://www.youtube.com/embed/dQw4w9WgXcQ", // Mock URL
  thumbnail: "https://images.unsplash.com/photo-1638961811114-65f0702701ec",
  duration: "3:45",
  title: "2024 Showreel"
};
